// Generated by purs version 0.15.16
import * as API_Account from "../API.Account/index.js";
import * as API_Document from "../API.Document/index.js";
import * as API_FormType from "../API.FormType/index.js";
import * as API_Search from "../API.Search/index.js";
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as GraphQL_Compound from "../GraphQL.Compound/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Steps_WorkQueue_DocumentIndex from "../Steps.WorkQueue.DocumentIndex/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Search from "../Widgets.Search/index.js";
var getQuery = /* #__PURE__ */ GraphQL_Join.getQuery(GraphQL_Join.singleJoinable);
var getQuery1 = /* #__PURE__ */ GraphQL_Join.getQuery(GraphQL_Query.joinGenQ);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString));
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var multiQuery_ = /* #__PURE__ */ GraphQL_Join.multiQuery_()(/* #__PURE__ */ GraphQL_Join.jqCons(/* #__PURE__ */ GraphQL_Join.jqCons(GraphQL_Join.jqNil)({
    reflectSymbol: function () {
        return "searchData";
    }
})()()()()(GraphQL_Compound.cqJoin))({
    reflectSymbol: function () {
        return "account";
    }
})()()()()(GraphQL_Query.joinGenQ));
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var runGraphQL_ = /* #__PURE__ */ GraphQL_Join.runGraphQL_(GraphQL_Query.qgql);
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(ordRNTY);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var alt = /* #__PURE__ */ Control_Alt.alt(Data_Maybe.altMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var getDecode = /* #__PURE__ */ GraphQL_Join.getDecode(GraphQL_Join.singleJoinable);
var getDecode1 = /* #__PURE__ */ GraphQL_Join.getDecode(GraphQL_Query.joinGenQ);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var except = /* #__PURE__ */ Control_Monad_Except_Trans.except(Effect_Aff.applicativeAff);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Either.applicativeEither);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(ordRNTY);
var fromFoldable1 = /* #__PURE__ */ Data_Set.fromFoldable(Data_List_Types.foldableList)(ordRNTY);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var fromFoldable2 = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray)(ordRNTY);
var fromFoldable3 = /* #__PURE__ */ Data_Array.fromFoldable(Data_Set.foldableSet);
var union = /* #__PURE__ */ Data_Set.union(ordRNTY);
var member = /* #__PURE__ */ Data_Map_Internal.member(ordRNTY);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var foldr = /* #__PURE__ */ Data_Foldable.foldr(Data_Foldable.foldableArray);
var Step3FormTypeResult = /* #__PURE__ */ (function () {
    function Step3FormTypeResult(value0) {
        this.value0 = value0;
    };
    Step3FormTypeResult.create = function (value0) {
        return new Step3FormTypeResult(value0);
    };
    return Step3FormTypeResult;
})();
var Step3DocumentResult = /* #__PURE__ */ (function () {
    function Step3DocumentResult(value0) {
        this.value0 = value0;
    };
    Step3DocumentResult.create = function (value0) {
        return new Step3DocumentResult(value0);
    };
    return Step3DocumentResult;
})();
var Step3FormTypeQuery = /* #__PURE__ */ (function () {
    function Step3FormTypeQuery(value0) {
        this.value0 = value0;
    };
    Step3FormTypeQuery.create = function (value0) {
        return new Step3FormTypeQuery(value0);
    };
    return Step3FormTypeQuery;
})();
var Step3DocumentQuery = /* #__PURE__ */ (function () {
    function Step3DocumentQuery(value0) {
        this.value0 = value0;
    };
    Step3DocumentQuery.create = function (value0) {
        return new Step3DocumentQuery(value0);
    };
    return Step3DocumentQuery;
})();
var step3PreloadRequest = function (v) {
    if (v instanceof Step3FormTypeQuery) {
        return getQuery(v.value0);
    };
    if (v instanceof Step3DocumentQuery) {
        return getQuery1(v.value0);
    };
    throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 204, column 23 - line 206, column 47): " + [ v.constructor.name ]);
};
var matchesRecentFormLookup = function (lookup1) {
    return function (recentForm) {
        if (lookup1.documentId instanceof Data_Maybe.Just) {
            return eq(recentForm.id)(lookup1.documentId.value0);
        };
        if (lookup1.documentId instanceof Data_Maybe.Nothing) {
            return eq(recentForm.student.id)(lookup1.studentId) && eq(recentForm.form_type.id)(lookup1.formId);
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 246, column 45 - line 250, column 56): " + [ lookup1.documentId.constructor.name ]);
    };
};
var matchesDocumentLookup = function (lookup1) {
    return function (doc) {
        if (lookup1.documentId instanceof Data_Maybe.Just) {
            return eq(doc.id)(lookup1.documentId.value0);
        };
        if (lookup1.documentId instanceof Data_Maybe.Nothing) {
            return eq(doc.student.id)(lookup1.studentId) && eq(doc.formId)(lookup1.formId);
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 239, column 36 - line 243, column 43): " + [ lookup1.documentId.constructor.name ]);
    };
};
var loadWorkQueue = function (state) {
    return function (ui) {
        return function (cache) {
            return Control_Monad_Except_Trans.runExceptT(bind(multiQuery_({
                account: API_Account.queryAccountInfo,
                searchData: API_Search.searchDataQuery
            }))(function (v) {
                var defTeacher = map(function (v1) {
                    return {
                        label: v1.name,
                        value: v1
                    };
                })(v.searchData.defaults.teacher);
                var defSemester = map(function (v1) {
                    return {
                        label: v1.name,
                        value: v1
                    };
                })(v.searchData.defaults.semester);
                var ui$prime = {
                    expandedForms: ui.expandedForms,
                    expandedStudents: ui.expandedStudents,
                    teacher: Widgets_BetterSelect.setSelected(ui.teacher)(defTeacher),
                    semester: Widgets_BetterSelect.setSelected(ui.semester)(defSemester),
                    search: Widgets_Search.loadSearchState(v.searchData)
                };
                return pure({
                    state: {
                        currentDoc: state.currentDoc,
                        documents: state.documents,
                        editDocs: state.editDocs,
                        forms: state.forms,
                        students: state.students,
                        teacher: map(function (v2) {
                            return v2.value;
                        })(Widgets_BetterSelect.selectedItem(ui$prime.teacher)),
                        semester: map(function (v2) {
                            return v2.value;
                        })(Widgets_BetterSelect.selectedItem(ui$prime.semester))
                    },
                    ui: ui$prime,
                    cache: {
                        formCache: cache.formCache,
                        loaded: cache.loaded,
                        account: v.account,
                        defTeacher: defTeacher,
                        defSemester: defSemester,
                        searchData: v.searchData
                    }
                });
            }));
        };
    };
};
var lazyLoadWorkQueue = function (state) {
    return function (ui) {
        return function (cache) {
            if (cache.loaded) {
                return pure1(new Data_Either.Right({
                    state: state,
                    ui: ui,
                    cache: cache
                }));
            };
            return loadWorkQueue(state)(ui)(cache);
        };
    };
};
var insertDocument = function (doc) {
    return function (state) {
        return {
            forms: state.forms,
            students: state.students,
            editDocs: state.editDocs,
            currentDoc: state.currentDoc,
            semester: state.semester,
            teacher: state.teacher,
            documents: Steps_WorkQueue_DocumentIndex.insertDoc(doc)(state.documents)
        };
    };
};
var newDocument = function (state) {
    return function (ftype) {
        return function (args) {
            return bind(runGraphQL_(API_Document.createDocument(ftype)(args)))(function (doc) {
                var newState = insertDocument(doc)(state);
                return pure(new Data_Tuple.Tuple(newState, doc));
            });
        };
    };
};
var initialWorkQueueCache = /* #__PURE__ */ (function () {
    return {
        account: {
            type: API_Account.TeacherAccount.value,
            student: Data_Maybe.Nothing.value
        },
        searchData: API_Search.emptySearchData,
        defTeacher: Data_Maybe.Nothing.value,
        defSemester: Data_Maybe.Nothing.value,
        formCache: Data_Map_Internal.empty,
        loaded: false
    };
})();
var getFormType = function (cache) {
    return function (formId) {
        return lookup(formId)(cache.formCache);
    };
};
var getForm = function (state) {
    return function (id) {
        return API_FormType.getSelectedForm(id)(state.forms);
    };
};
var getDocument = function (state) {
    return function (ftype) {
        return function (docId) {
            return bind(runGraphQL_(API_Document.fetchDocumentQuery(ftype)(docId)))(function (doc) {
                var newState = insertDocument(doc)(state);
                return pure(new Data_Tuple.Tuple(newState, doc));
            });
        };
    };
};
var getDocByStudent = function (state) {
    return function (dl) {
        var loadedDocs = fromFoldable(Steps_WorkQueue_DocumentIndex.listDocs(state.documents));
        if (dl.documentId instanceof Data_Maybe.Just) {
            return Steps_WorkQueue_DocumentIndex.getDocById(dl.documentId.value0)(state.documents);
        };
        if (dl.documentId instanceof Data_Maybe.Nothing) {
            return alt(Steps_WorkQueue_DocumentIndex.getDocByLookup(dl)(state.documents))(Data_Array.find(matchesDocumentLookup(dl))(loadedDocs));
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 223, column 5 - line 227, column 97): " + [ dl.documentId.constructor.name ]);
    };
};
var isLockedDocument = function (state) {
    return function (lookup1) {
        var recentFormLocked = Data_Maybe.maybe(false)(function ($101) {
            return Data_Maybe.isJust((function (v) {
                return v.locked_at;
            })($101));
        })(Data_Array.find(matchesRecentFormLookup(lookup1))(state.editDocs));
        return Data_Maybe.maybe(recentFormLocked)(function ($102) {
            return Data_Maybe.isJust((function (v) {
                return v.locked_at;
            })($102));
        })(getDocByStudent(state)(lookup1));
    };
};
var getDoc = function (state) {
    return function (id) {
        return Steps_WorkQueue_DocumentIndex.getDocById(id)(state.documents);
    };
};
var decodeStep3PreloadQuery = function (query) {
    return function (json) {
        if (query instanceof Step3FormTypeQuery) {
            return map1(Step3FormTypeResult.create)(getDecode(query.value0)(json));
        };
        if (query instanceof Step3DocumentQuery) {
            return map1(Step3DocumentResult.create)(getDecode1(query.value0)(json));
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 209, column 38 - line 213, column 55): " + [ query.constructor.name ]);
    };
};
var collectPreloadedStep3Resources = function (acc) {
    return function (v) {
        if (v instanceof Step3FormTypeResult) {
            return {
                documents: acc.documents,
                formTypes: Data_Array.snoc(acc.formTypes)(v.value0)
            };
        };
        if (v instanceof Step3DocumentResult) {
            return {
                formTypes: acc.formTypes,
                documents: Data_Array.snoc(acc.documents)(v.value0)
            };
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 279, column 38 - line 283, column 55): " + [ v.constructor.name ]);
    };
};
var runStep3PreloadQueries = function (queries) {
    if (Data_Array["null"](queries)) {
        return pure({
            formTypes: [  ],
            documents: [  ]
        });
    };
    if (Data_Boolean.otherwise) {
        return bind(GraphQL_Join.runMultiQuery(map2(step3PreloadRequest)(queries)))(function (responses) {
            return bind(except(sequence(Data_Array.zipWith(decodeStep3PreloadQuery)(queries)(responses))))(function (decoded) {
                return pure(foldl(collectPreloadedStep3Resources)({
                    formTypes: [  ],
                    documents: [  ]
                })(decoded));
            });
        });
    };
    throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 193, column 1 - line 195, column 93): " + [ queries.constructor.name ]);
};
var preloadStep3Resources = function (state) {
    return function (cache) {
        return function (maybeFtype) {
            return function (maybeDoc) {
                var seedPreload = function (state$prime) {
                    return function (cache$prime) {
                        return function (maybeFtype$prime) {
                            return function (maybeDoc$prime) {
                                var withFormType = (function () {
                                    if (maybeFtype$prime instanceof Data_Maybe.Nothing) {
                                        return cache$prime;
                                    };
                                    if (maybeFtype$prime instanceof Data_Maybe.Just) {
                                        return {
                                            account: cache$prime.account,
                                            defSemester: cache$prime.defSemester,
                                            defTeacher: cache$prime.defTeacher,
                                            loaded: cache$prime.loaded,
                                            searchData: cache$prime.searchData,
                                            formCache: insert(maybeFtype$prime.value0.id)(maybeFtype$prime.value0)(cache$prime.formCache)
                                        };
                                    };
                                    throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 164, column 28 - line 166, column 96): " + [ maybeFtype$prime.constructor.name ]);
                                })();
                                if (maybeDoc$prime instanceof Data_Maybe.Nothing) {
                                    return {
                                        state: state$prime,
                                        cache: withFormType
                                    };
                                };
                                if (maybeDoc$prime instanceof Data_Maybe.Just) {
                                    return {
                                        state: insertDocument(maybeDoc$prime.value0)(state$prime),
                                        cache: withFormType
                                    };
                                };
                                throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 167, column 12 - line 169, column 82): " + [ maybeDoc$prime.constructor.name ]);
                            };
                        };
                    };
                };
                var currentDocumentQuery = function (state$prime) {
                    return function (maybeDoc$prime) {
                        if (maybeDoc$prime instanceof Data_Maybe.Just) {
                            return Data_Maybe.Nothing.value;
                        };
                        if (maybeDoc$prime instanceof Data_Maybe.Nothing && state$prime.currentDoc instanceof Data_Maybe.Just) {
                            var $99 = Data_Maybe.isJust(getDocByStudent(state$prime)(state$prime.currentDoc.value0));
                            if ($99) {
                                return Data_Maybe.Nothing.value;
                            };
                            return map(function (recentForm) {
                                return new Step3DocumentQuery(API_Document.fetchDocumentQuery(recentForm.form_type)(recentForm.id));
                            })(Data_Array.find(matchesRecentFormLookup(state$prime.currentDoc.value0))(state$prime.editDocs));
                        };
                        if (maybeDoc$prime instanceof Data_Maybe.Nothing && state$prime.currentDoc instanceof Data_Maybe.Nothing) {
                            return Data_Maybe.Nothing.value;
                        };
                        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 172, column 45 - line 183, column 20): " + [ maybeDoc$prime.constructor.name, state$prime.currentDoc.constructor.name ]);
                    };
                };
                var ftypesSel = fromFoldable1(map3(function (v) {
                    return v.id;
                })(Internal_SelectionMap.listSelected(state.forms)));
                var ftypesEdit = fromFoldable2(map2(function (v) {
                    return v.form_type.id;
                })(state.editDocs));
                var seeded = seedPreload(state)(cache)(maybeFtype)(maybeDoc);
                var ftypeIds = fromFoldable3(union(ftypesSel)(ftypesEdit));
                var missingFtypeIds = Data_Array.filter(function (id) {
                    return !member(id)(seeded.cache.formCache);
                })(ftypeIds);
                var currentDocQuery = currentDocumentQuery(seeded.state)(maybeDoc);
                var preloadQueries = append(map2(function ($103) {
                    return Step3FormTypeQuery.create(API_FormType.formQueryRequest($103));
                })(missingFtypeIds))(Data_Maybe.maybe([  ])(function (query) {
                    return [ query ];
                })(currentDocQuery));
                return bind(runStep3PreloadQueries(preloadQueries))(function (preload) {
                    var formCache = foldr(function (f) {
                        return function (m) {
                            return insert(f.id)(f)(m);
                        };
                    })(seeded.cache.formCache)(preload.formTypes);
                    return pure({
                        state: foldl(Data_Function.flip(insertDocument))(seeded.state)(preload.documents),
                        cache: {
                            account: seeded.cache.account,
                            defSemester: seeded.cache.defSemester,
                            defTeacher: seeded.cache.defTeacher,
                            loaded: seeded.cache.loaded,
                            searchData: seeded.cache.searchData,
                            formCache: formCache
                        }
                    });
                });
            };
        };
    };
};
export {
    initialWorkQueueCache,
    loadWorkQueue,
    lazyLoadWorkQueue,
    getForm,
    preloadStep3Resources,
    getFormType,
    getDoc,
    getDocByStudent,
    isLockedDocument,
    newDocument,
    getDocument,
    insertDocument
};
//# sourceMappingURL=index.js.map
